<template>
	<div class="privacy-modal form">
		<Spinner
			v-if="innerLoading"
			size="md"
		/>
		<div class="center-privacy">
			<p>{{ translateKey('signup_modal_text', { centerName: centerName }) }} {{ translateKey('signup_privacy_text', { centerName: centerName }) }}</p>
			<QFormFieldCheckbox
				v-model="helpers.privacy"
				name="privacy-check"
				:label="translateKey('common_accept_privacy_policy')"
				rules="required"
				:error-message="translateKey('common_required_field_error')"
			>
				<a
					:href="privacyLink"
					target="_blank"
				>{{ translateKey("common_accept_privacy_policy") }}</a>
			</QFormFieldCheckbox>
		</div>
		<hr>
		<div class="extra-offers">
			<p>{{ translateKey("common_would_receive_offers_email_sms") }}</p>
			<QFormFieldRadio
				v-model="offers"
				name="offers-check"
				:options="offersOptions"
				:error-message="translateKey('common_required_field_error')"
			/>
		</div>
		<div class="wrap-buttons">
			<QButton
				variant="primary"
				@click="proceedButtonClicked"
			>
				{{ translateKey("label_proceed") }}
			</QButton>
			<span class="sep">{{ translateKey("label_or") }}</span>
			<QButton
				variant="outline-primary"
				@click="declineButtonClicked"
			>
				{{ translateKey("label_decline_and_logout") }}
			</QButton>
		</div>
	</div>
</template>

<script lang="ts" src="./privacy-modal.ts" />
<style lang="scss" src="./privacy-modal.scss"></style>
